import { Clear, Create, Done, PhotoCameraFront } from "@mui/icons-material"
import { Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useState } from "react"
import EdicaoCamerasApp from "../EdicaoCamerasApp/EdicaoCamerasApp"
import SnapshotModal from "../../../../../../Components/SnapshotModal/SnapshotModal"
import OneInput from "../../../../../../Components/OneInput/OneInput"

const CardCamerasApp = ({ cameraApp, idCentral, moveCard, findCard }) => {
    const { id, exibe_monitoramento } = cameraApp

    const [openSnapshot, setOpenSnapshot] = useState(false)

    const [openCameraApp, setOpenCameraApp] = useState(false)

    const editAutomacao = () => {
        setOpenCameraApp(true)
    }

    return (
        <Grid
            xs={12}
            sx={{ alignItems: 'center', paddingTop: '5px' }}
            container
        >
            {openSnapshot &&
                <SnapshotModal
                    openModal={openSnapshot}
                    setOpenModal={setOpenSnapshot}
                    cameraId={id}
                />
            }
            {openCameraApp &&
            <EdicaoCamerasApp openCameraApp={openCameraApp} setOpenCameraApp={setOpenCameraApp} idToEdit={id} idCentral={idCentral} />
            }
            {/* <Grid xs={0.5} sx={{ justifyContent: 'center', display: 'flex' }}>
                <Reorder
                // sx={{ cursor: 'pointer' }}
                />
            </Grid> */}
            <Grid container xs sx={{ border: '1px solid grey', padding: '10px', borderRadius: '5px', alignItems: 'center' }}>
                <Grid md={9}>
                    <Grid container xs={7} sx={{ alignItems: 'center' }}>
                        <Grid xs={12} md={1.5}>
                            <Typography fontSize="13px" fontWeight='400' >Câmera: </Typography>
                        </Grid>
                        <Grid xs={12} md={10}>
                            <OneInput
                                defaultValue={cameraApp.descricao}
                                readOnly
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid md={1}
                >
                    <span title="Em breve">
                        <PhotoCameraFront sx={{ color: 'gray', cursor: 'pointer' }} onClick={() => { setOpenSnapshot(true) }}/>
                    </span>
                </Grid>
                <Grid md={1.5}>
                    <Grid xs={7} container sx={{ alignItems: 'center' }}>
                        <Grid xs={12} md>
                            {exibe_monitoramento ? (<Done sx={{ color: "green" }}/>) : (<Clear sx={{ color: "red" }}/>)}
                        </Grid>
                        <Grid xs={12} md={9}>
                            <Typography fontSize="13px" fontWeight='400' >Visível </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid md>
                    <Grid xs={1} container sx={{ alignItems: 'center' }}>
                        <Create sx={{ cursor: 'pointer', fontSize: '18px' }} onClick={() => { editAutomacao() }}/>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default CardCamerasApp
